import { FetchStatus } from "src/globalConsts";
import { SystemAdminNotification } from "src/globalTypes";
import { reducer } from "ts-action";
import { on } from "ts-action-immer";
import {
  errorReceiveAllNotifications,
  receiveAllNotfications,
  requestFetchAllNotifications,
  resolveNotifications,
} from "../actionCreators";
import { receiveSystemAdminNotifications } from "./actionCreators";

export type SystemAdminNotificationsReducer = {
  messages: SystemAdminNotification[];
  fetchStatus: FetchStatus;
};

const initialState: SystemAdminNotificationsReducer = {
  messages: [],
  fetchStatus: FetchStatus.Uninitialized,
};

const { Uninitialized, FetchingInitial, Fetched, Failed, Refetching } =
  FetchStatus;

const systemAdminNotificationsReducer = reducer(
  initialState,
  on(requestFetchAllNotifications, (state) => {
    const isFirstFetch = state.fetchStatus === Uninitialized;
    state.fetchStatus = isFirstFetch ? FetchingInitial : Refetching;
  }),
  on(receiveAllNotfications, (state, { payload: { notifications } }) => {
    state.messages = notifications.systemAdminNotifications;
    state.fetchStatus = Fetched;
  }),
  on(
    receiveSystemAdminNotifications,
    (state, { payload: { notifications } }) => {
      state.messages = [...notifications];
      state.fetchStatus = Fetched;
    }
  ),
  on(resolveNotifications, (state, { payload: { notificationIds } }) => {
    state.messages = [...state.messages].filter(
      (notif) => !notificationIds.includes(notif.notificationId)
    );
  }),
  on(errorReceiveAllNotifications, (state) => {
    state.fetchStatus = Failed;
  })
);

export default systemAdminNotificationsReducer;
